export type CountFittingTagsOptions = {
  /** The width of each tag chip, in the order of the tags. */
  tagWidths: number[];
  /** The width of the cell content. */
  availableWidth: number;
  /** The width of the "+N" chip that replaces the tags that do not fit. */
  overflowChipWidth: number;
  /** The space between 2 chips. */
  gap: number;
};

/**
 * The number of tags that fit on 1 line of a table cell. When not all tags
 * fit, the line also keeps room for the "+N" chip.
 */
export function countFittingTags({
  tagWidths,
  availableWidth,
  overflowChipWidth,
  gap,
}: CountFittingTagsOptions): number {
  // No width yet: the first render before the layout.
  if (availableWidth <= 0) {
    return tagWidths.length;
  }

  const allTagsWidth = sum(tagWidths) + gap * Math.max(tagWidths.length - 1, 0);
  if (allTagsWidth <= availableWidth) {
    return tagWidths.length;
  }

  let usedWidth = overflowChipWidth;
  let count = 0;
  for (const tagWidth of tagWidths) {
    usedWidth += tagWidth + gap;
    if (usedWidth > availableWidth) {
      break;
    }
    count++;
  }
  return count;
}

function sum(values: number[]): number {
  return values.reduce((total, value) => total + value, 0);
}
